import React from 'react';
import './NotFound.css';
import notFoundImage from '../../static/image/404.png';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <img src={notFoundImage} alt="404" className="error-image" />
        <h1 className="error-title">功能即将上线</h1>
        <p className="error-message">
          敬请期待...
        </p>
      </div>
    </div>
  );
};

export default NotFound;
